import Vue from 'vue'
import {buildMenu} from '@azinformatica/loki'
import RootPage from '@/views/pages/RootPage.vue'
import router from '@/views/routers'
import store from '@/core/store'
import exceptionHandler from '@/core/exceptions/ExceptionHandler'
import i18n from '@/i18n'
import WebsocketHelper from '@/core/utils/WebsocketHelper'

class RootPageCreator {
    createInstance() {
        const identidadeCliente = store.state.parametros.propriedadesCompraDiretas.identidadeCliente === 'ES'
        if(!identidadeCliente)
            router.options.routes = [ ...router.options.routes.filter(r => r.name !== 'ComprasDiretasLegadas')]

        new Vue({
            i18n,
            router,
            store,
            render: h => h(RootPage),
            async created() {
                const actionsMenu = buildMenu(store, router)

                actionsMenu.forEach(menu => {
                    if(menu.name === 'Sobre')
                        menu.expanded = !menu.expanded
                })

                this.$store.commit('SET_MENU_ACTIONS', actionsMenu)

                await this.conectarComWebsocket()
            },
            methods: {
                async conectarComWebsocket(){
                    if(this.ehSessaoValida(this.$store.state)){
                        await (new WebsocketHelper()).conectar(this.$store.state.loki.user, this.$store.state.token)

                        const intervalo = setInterval(async () => {
                            if(!this.$store.state.websocketService)
                                await (new WebsocketHelper()).conectar(this.$store.state.loki.user, this.$store.state.token)
                            else
                                clearInterval(intervalo)
                        }, 10000)
                    }
                },

                ehSessaoValida(state){
                    return state.loki.user.domainId && state.loki.user.domainType !== 'DEFAULT'
                },
            },
            errorCaptured(error) {
                exceptionHandler.execute(error)
                return false
            }
        }).$mount('#app')
    }

    createBootstrapError({response}) {
        let mensagem = ''
        if(response && response.data && response.data.message){
            mensagem = response.data.message
        }
        new Vue({
            el: '#app',
            render(createElement) {
                return createElement('div', {
                    'class': 'erro-inicializacao'
                }, [
                    createElement('div', {}, [
                        createElement('i', {
                            'class': 'far fa-surprise'
                        }),
                        createElement('p', 'Ocorreu um erro na inicialização desta aplicação.'),
                        createElement('p', {'class':'mensagem'}, [`${mensagem}`])
                    ])
                ])
            },
        })
    }
}

export default new RootPageCreator()
